import { supabase } from '../lib/supabase';
import { PayoutStructure } from '../types/payout';

export async function fetchPayoutStructures(userId: string) {
  const { data, error } = await supabase
    .from('payout_structures')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data as PayoutStructure[];
}

export async function getDefaultPayoutStructure(userId: string) {
  const { data, error } = await supabase
    .from('payout_structures')
    .select('*')
    .eq('user_id', userId)
    .eq('is_default', true)
    .single();

  if (error) throw error;
  return data as PayoutStructure;
}

export async function savePayoutStructure(structure: Omit<PayoutStructure, 'id' | 'created_at' | 'updated_at'>) {
  const { data, error } = await supabase
    .from('payout_structures')
    .insert(structure)
    .select()
    .single();

  if (error) throw error;
  return data as PayoutStructure;
}

export async function updatePayoutStructure(id: string, updates: Partial<PayoutStructure>) {
  const { data, error } = await supabase
    .from('payout_structures')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as PayoutStructure;
}

export async function deletePayoutStructure(id: string) {
  const { error } = await supabase
    .from('payout_structures')
    .delete()
    .eq('id', id);

  if (error) throw error;
}